import React, {useEffect, useState} from 'react';
import {Alert, Box, Button, Container, Divider, Paper, TextField, Typography} from '@mui/material';
import {useNavigate, useSearchParams} from 'react-router-dom';
import {useAuth} from "../../context/AuthContext";
import {api} from "../../services/apiService";

export default function ResetPassword() {
    const navigate = useNavigate();
    const {user} = useAuth();
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(false);
    const [searchParams] = useSearchParams();
    const [token, setToken] = useState(null);

    const [passwordUpdated, setPasswordUpdated] = useState(false);

    const handleLogin = async (e) => {
        setLoading(true);
        e.preventDefault();
        setError('');

        if (!e.currentTarget.checkValidity()) {
            e.currentTarget.reportValidity();
            setLoading(false);
            return;
        }

        const formData = new FormData(e.currentTarget);
        const password = formData.get('password');
        const password_confirmation = formData.get('password_confirmation');

        if (password !== password_confirmation) {
            setError('Les mots de passe ne correspondent pas.');
            setLoading(false);
            return;
        }

        // mettre à jour le password
        api.post('auth/reset_password', {
            password: password,
            password_confirmation: password_confirmation,
            token: token,
        })
            .then(res => {
                if (res.status === 200) {
                    setSuccess(res.data.message);
                    setPasswordUpdated(true);
                }
            })
            .catch(err => {
                setError(err.response?.data?.message);
            })

        setLoading(false);
    };

    useEffect(() => {
        if (user) {
            navigate('/');
        }

        // on vérifie la validité du token
        const token = searchParams.get('token');

        api.post('auth/check_reset_token', {token})
            .then(() => {
                setToken(token);
            })
            .catch(err => {
                setError(err.response?.data?.message);
                setTimeout(() => {
                    navigate('/login');
                }, 5000)
            })
    }, [user, navigate, searchParams])

    return (
        <Container maxWidth="sm"
                   sx={{minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            <Paper elevation={6} sx={{p: 4, width: '100%'}}>
                <Box sx={{textAlign: 'center', mb: 3}}>
                    <Typography variant="h4" component="h1" fontWeight={700}>
                        Réinitialisez votre mot de passe
                    </Typography>
                </Box>

                <Divider sx={{mb: 3}}/>

                {error && (
                    <Alert severity="error" sx={{mb: 2}}>
                        {error}
                    </Alert>
                )}

                {success && (
                    <Alert severity="success" sx={{mb: 2}}>
                        {success}
                    </Alert>
                )}

                {passwordUpdated ?
                    <Button variant="contained" size="large" fullWidth sx={{mt: 1}} onClick={() => navigate('/login')}>
                        Retour à la page de connexion
                    </Button>
                    :
                    <Box component="form" onSubmit={handleLogin}
                         sx={{display: 'flex', flexDirection: 'column', gap: 2}}>
                        <TextField name="password" label="Nouveau mot de passe" type="password" variant="outlined"
                                   fullWidth
                                   required/>
                        <TextField name="password_confirmation" label="Confirmation" type="password" variant="outlined"
                                   fullWidth
                                   required/>
                        <Button type="submit" variant="contained" size="large" sx={{mt: 1}} disabled={loading}>
                            Envoyer
                        </Button>
                    </Box>
                }


            </Paper>
        </Container>
    );
}